//cheque_type : نوع چک را مشخص می کند و دریافتی یا پرداختی .در ابتدا مقدارش 0 است - وقتی نوع تراکنش را انتخای می کنیم هم 0 می شود

import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModulesComponent } from '../../../../service/modules/modules.component';
import { ServerService } from '../../../../service/server/server.service';
import { ChequeSelectComponent } from '../../cheque/cheque-select/cheque-select.component';
import { ChequeDetaileComponent } from '../../cheque/cheque-detaile/cheque-detaile.component';

@Component({
  selector: 'app-financial2-detaile',
  templateUrl: './financial2-detaile.component.html',
  styleUrls: ['./financial2-detaile.component.scss']
})
export class Financial2DetaileComponent implements OnInit, OnDestroy {
  public isOnline: any;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any;
  lang: any;
  type_task: number | undefined;
  form1_group: FormGroup | any;
  user_info: any;
  user_id: number | any;
  id: number | undefined;
  i: number | undefined;
  code: number | undefined;
  title: string | undefined;
  search_array: any = [];
  financial: number | undefined;
  cheque: boolean = false;
  introducing_cheque: boolean = false;
  cheque_temp: number | undefined;
  result: any = [];
  change: boolean = false;
  user: number | undefined;
  cheque_type: number = 0;
  close_after_save: string | undefined;
  document: number | undefined;
  document_type: number | undefined;
  token: number | undefined;

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any, private dialog: MatDialog
    , private matDialogRef: MatDialogRef<Financial2DetaileComponent>) {
    this.server = this.serverService.get_server();
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    if (dialog_data) {
      this.type_task = dialog_data.type_task;
      this.token = dialog_data.token;
      this.financial = dialog_data.financial;
      this.document = dialog_data.document;
      this.create_form1();
      this.user = dialog_data.user;
      this.id = dialog_data.id;
      this.title = dialog_data.title;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      if (this.document) {
        this.get_document();
      }
      if (this.type_task == 1) {
      }
      if (this.type_task == 2) {
        this.check_access(4, 1);
      }
      if (this.type_task == 3) {
        this.form1_group.patchValue({
          title: dialog_data.search_array.title,
          payment_type: dialog_data.search_array.payment_type,
          payment_type_title: dialog_data.search_array.payment_type_title,
          user_title: dialog_data.search_array.user_title,
          user: dialog_data.search_array.user,
        })
      }
    }
  }//end consructor

  ngOnInit() {
    this.server = this.serverService.get_server();
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.user_info = JSON.parse(<any>localStorage.getItem('user_info'));
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
  }

  create_form1() {
    this.form1_group = new FormGroup({
      'amount': new FormControl(null),
      'sort': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'payment_type_title': new FormControl(null),
      'payment_type': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'user_title': new FormControl(null),
      'user': new FormControl(null, [Validators.pattern('[0-9]{1,}')]),
      'cheque_title': new FormControl(null),
      'cheque': new FormControl(null, [Validators.pattern('[0-9]{1,}')])
    });
    if (this.type_task == 2 || this.type_task == 1) {
      this.form1_group.controls['payment_type'].setValidators([Validators.required]);
    }

  }

  get_document() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1952, document: this.document }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.document_type = res['result'][0].document_type;
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  save(type_task: number, excel: number, close: string) {
    this.close_after_save = close;
    this.check_access(type_task, excel);
  }

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid && (this.type_task == 1 || this.type_task == 2)) {
      return false;
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 1) { this.insert(); }
            if (type_task == 2) { this.update(); }
            if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.get_data(); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  search(excel: number) {
    this.matDialogRef.close({
      title: this.form1_group.value.title,
      payment_type: this.form1_group.value.payment_type,
      payment_type_title: this.form1_group.value.payment_type_title,
      user_title: this.form1_group.value.user_title,
      user: this.form1_group.value.user,
      export_excel: excel
    })
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1925, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.form1_group.patchValue({
            'amount': res['result'][0].finance_financial2_amount,
            'sort': res['result'][0].finance_financial2_sort,
            'user': res['result'][0].finance_financial_user,
            'user_title': res['result'][0].user_title,
            'payment_type': res['result'][0].finance_financial2_payment_type,
            'payment_type_title': res['result'][0].finance_payment_type_title,
            'cheque_title': res['result'][0].site_cheque_type_title + "/" + res['result'][0].site_bank_title + "/" + res['result'][0].cheque_number + "/" + res['result'][0].accounts_number,
            'cheque': res['result'][0].site_cheque_id,
          }
          );
          this.cheque_temp = res['result'][0].site_cheque_id;
          this.cheque = res['result'][0].finance_payment_type_cheque;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 6034, "user_id": this.user_id
      , 'amount': this.form1_group.value.amount
      , 'cheque': this.form1_group.value.cheque
      , 'payment_type': this.form1_group.value.payment_type
      , 'sort': this.form1_group.value.sort
      , 'cheque_type': this.cheque_type
      , 'document_type': this.document_type
      , 'financial': this.financial
      , 'token': this.token
      , 'trash': 3
      , 'ref': 2
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.change = true;
          this.result.push(res['result'][0]);
          if (this.cheque_type > 0) this.update_cheque();
          else {
            if (this.close_after_save == 'close') {
              this.close(this.result);
            } else {

            }
            var pe_message = "با موفقیت ذخیره شد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
          }
          this.form1_group.patchValue({
            'payment_type_title': null,
            'payment_type': null,
            'cheque_title': null,
            'cheque': null,
            'amount': null
          })
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "شماره چک انتخابی قبلا در سیستم دریافت و پرداخت استفاده شده است";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end insert

  update() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      'address': 1922, "user_id": this.user_id
      , 'amount': this.form1_group.value.amount
      , 'payment_type': this.form1_group.value.payment_type
      , 'sort': this.form1_group.value.sort
      , 'cheque': this.form1_group.value.cheque
      , 'type': this.cheque_type
      , 'id': this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.change = true;
          this.result = res['result'][0];
          if (this.cheque == true && this.form1_group.value.cheque != this.cheque_temp) {
            this.update_cheque();
          } else {
            this.close(this.result);
            var pe_message = "با موفقیت ذخیره شد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
          }
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "عنوان  مي بايست منحصر به فرد باشد";
          var pe_action = "بستن";
          this.recieve_message(true, 'The title should be unique', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update

  update_cheque() {
    var obj = {
      address: 1930, cheque: this.form1_group.value.cheque,
      document_type: this.document_type, cheque_type: this.cheque_type
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (this.type_task == 2) {
            this.update_cheque2();
          } else {
            if (this.close_after_save == 'close') {
              this.close(this.result);
            } else {

            }
            var pe_message = "با موفقیت ذخیره شد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
          }
        }//end if
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  update_cheque2() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1931, cheque: this.cheque_temp }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (this.close_after_save == 'close') {
            this.close(this.result);
          } else {

          }
          var pe_message = "با موفقیت ذخیره شد";
          var pe_action = "بستن";
          this.recieve_message(true, 'Done successfully', pe_message, 1, 'close', pe_action);
        }//end if
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  load_services(id: number) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 177) {
            this.form1_group.patchValue({
              'payment_type': res.id,
              'payment_type_title': res.title
            });
            this.cheque_type = 0;
            this.get_payment_type(res.id);
          }
          if (id == 161) {
            this.form1_group.patchValue({
              'user': res.id,
              'user_title': res.title
            })
          }
        }
      }
    )

  }

  get_payment_type(id: number) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1929, id: id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].finance_payment_type_cheque) {
            this.cheque = res['result'][0].finance_payment_type_cheque;
          } else {
            this.cheque = false;
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  select_introducing_cheque() {
    const dialogRef = this.dialog.open(ChequeDetaileComponent, {
      width: '45rem',
      height: 'auto',
      data: { type_task: 1, code: 181, type: 1 }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.form1_group.patchValue({
            'cheque_title': res.result.site_bank_title + "/" + res.result.site_cheque_number + "/" + res.result.accounts_number,
            'cheque': res.result.site_cheque_id
          })
        }
        this.cheque_type = res.result.site_cheque_type;
      }
    )

  }

  select_cheque() {
    const dialogRef = this.dialog.open(ChequeSelectComponent, {
      width: '64rem',
      height: 'auto',
      data: { user: this.user, document_type: this.document_type }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.form1_group.patchValue({
            'cheque_title': res.result.site_cheque_type_title + "/" + res.result.site_bank_title + "/" + res.result.cheque_number + "/" + res.result.accounts_number,
            'cheque': res.result.site_cheque_id
          });
          this.cheque_type = res.result.site_cheque_type;
        }
      }
    )
  }


  reset_input(id: number) {
    if (id == 177) {
      this.form1_group.patchValue({
        'payment_type_title': null,
        'payment_type': null
      })
    }
    if (id == 161) {
      this.form1_group.patchValue({
        'user': null,
        'user_title': null
      })
    }
    if (id == 181) {
      this.form1_group.patchValue({
        'cheque': null,
        'cheque_title': null
      })
    }
  }


  close(result: any) {
    this.matDialogRef.close({ result: result, change: this.change });
  }
  //**************************************************
  required() {
    if (this.type_task == 1 || this.type_task == 2) {
      return true;
    }
    else {
      return false;
    }
  }

  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
